import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from './auth.service';
import { SessionStore } from './session.store';

export const authGuard: CanActivateFn = async (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const sessionStore = inject(SessionStore);

  if (await authService.ensureValidSession()) {
    if (sessionStore.snapshot()?.mustChangePassword) {
      return router.createUrlTree(['/change-password']);
    }
    return true;
  }

  return router.createUrlTree(['/login'], {
    queryParams: { redirectTo: state.url || '/' },
  });
};
